<template>
  <div class="cyber-swapleg">
    <div class="cyber-swapleg__header">
      <i class="mdi mdi-source-branch cyber-swapleg__icon"></i>
      <h5 class="cyber-swapleg__title">BINARY LEG</h5>
    </div>
    <div class="cyber-swapleg__buttons">
      <button
        @click="swapLeg('left')"
        class="cyber-swapleg__btn"
        :class="{
          'cyber-swapleg__btn--active': !$store.getters.currentUser.right,
          'cyber-swapleg__btn--available': $store.getters.currentUser.right,
        }"
        :disabled="!$store.getters.currentUser.right"
      >
        <i class="mdi mdi-arrow-left-bold-circle-outline"></i>
        <span>LEFT</span>
        <i
          v-if="!$store.getters.currentUser.right"
          class="mdi mdi-check-circle cyber-swapleg__check"
        ></i>
      </button>

      <button
        @click="swapLeg('right')"
        class="cyber-swapleg__btn"
        :class="{
          'cyber-swapleg__btn--active': $store.getters.currentUser.right,
          'cyber-swapleg__btn--available': !$store.getters.currentUser.right,
        }"
        :disabled="$store.getters.currentUser.right"
      >
        <i class="mdi mdi-arrow-right-bold-circle-outline"></i>
        <span>RIGHT</span>
        <i
          v-if="$store.getters.currentUser.right"
          class="mdi mdi-check-circle cyber-swapleg__check"
        ></i>
      </button>
    </div>
  </div>
</template>

<style scoped>
.cyber-swapleg {
  background: linear-gradient(135deg, #252525, #2e2e2e);
  border: 1px solid #3d3d37;
  border-radius: 14px;
  padding: 20px;
  margin-bottom: 20px;
  position: relative;
  overflow: hidden;
}

.cyber-swapleg::before {
  content: '';
  position: absolute;
  top: 0; left: 0; right: 0;
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(176, 154, 78, 0.3), transparent);
}

.cyber-swapleg__header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 15px;
}

.cyber-swapleg__icon {
  color: #B09A4E;
  font-size: 1.3rem;
  text-shadow: 0 0 8px rgba(176, 154, 78, 0.3);
}

.cyber-swapleg__title {
  font-family: 'Orbitron', sans-serif !important;
  font-size: 0.75rem !important;
  color: #9A998F !important;
  letter-spacing: 0.12em;
  margin: 0 !important;
}

.cyber-swapleg__buttons {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.cyber-swapleg__btn {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 18px;
  border-radius: 10px;
  border: 1px solid #3d3d37;
  background: rgba(26, 26, 26, 0.5);
  color: #9A998F;
  font-family: 'Orbitron', sans-serif;
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.1em;
  cursor: pointer;
  transition: all 0.3s ease;
}

.cyber-swapleg__btn--active {
  background: linear-gradient(135deg, rgba(176, 154, 78, 0.12), rgba(176, 154, 78, 0.05));
  border-color: rgba(176, 154, 78, 0.3);
  color: #B09A4E;
  box-shadow: 0 0 15px rgba(176, 154, 78, 0.1);
  cursor: default;
}

.cyber-swapleg__btn--active i {
  color: #B09A4E;
}

.cyber-swapleg__btn--available {
  cursor: pointer;
}

.cyber-swapleg__btn--available:hover {
  background: rgba(123, 191, 181, 0.05);
  border-color: rgba(123, 191, 181, 0.2);
  color: #7BBFB5;
}

.cyber-swapleg__btn--available:hover i {
  color: #7BBFB5;
}

.cyber-swapleg__check {
  margin-left: auto;
  font-size: 1rem;
  color: #B09A4E;
  text-shadow: 0 0 6px rgba(176, 154, 78, 0.4);
}
</style>

<script>
import { userMixin } from "@/mixins/";

export default {
  name: "swap-binary-leg",
  mixins: [userMixin],
};
</script>
